require('es6-promise').polyfill();

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use( Vuex )

import { client } from './modules/client.js';
import { services } from './modules/services.js';
import { chargingstations } from './modules/chargingstations.js';
import { users } from './modules/users.js';
import { display } from './modules/display.js';
import { filters } from './modules/filters.js';
import { flashMessage } from './modules/flashMessage.js';

export default new Vuex.Store({
	modules: {
		client,
		services,
		chargingstations,
		users,
		display,
		filters,
		flashMessage
	}
});
